<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ay1P42/tc-custom/9781429910682.jpg?1731790826330" alt="This image is the cover for the book Roaring Thunder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roaring Thunder
      </h1>
      <p class="bookDescription body article font2">
        <p>The story of the jet age of aviation revolves around remarkable geniuses--including Sir Frank Whittle, the British inventor of the jet engine; Hans von Ohain, a German jet engine designer who comes to work for the U.S.; famed aeronautical engineer Kelly Johnson; the daring test pilot Tex Johnston, and many more--brilliant men who conceived these early extraordinary airplanes and had the courage to fly them to new horizons.<br/><br/><i>Roaring Thunder</i> blends real life adventures of the industry giants with the fictional Vance Shannon and his aviation family. Shannon, a prototypical American test pilot, sees and guides the birth of American jet aviation, while his sons, Tom and Harry fly the new jets in combat. Their aviation careers are blessed by their skill and courage, and they help usher in the greatest advance in aviation history with the birth of the jet transport. The Shannons serve as counterparts to the real-life heroes, creating continuity and explaining the intricacies, successes, and setbacks of a brand new industry.<br/><br/>The dramatic, totally accurate story of the beginning of the jet age is presented against a background of personalities, real and fictional who bring the story to life, and represent the first stage in the first ever fiction trilogy about the history of the aerospace industry.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter J. Boyne
      </h2>
      
      <p class="authorDescription body article"><P>WALTER J. BOYNE is the former director of the National Air and Space Museum of the Smithsonian Institution, he retired in 1986 to pursue a career as a novelist and consultant. He is one of a select few authors whose books have made both the fiction and the nonfiction bestseller lists of <I>The New York Times</I>. His recent books include <I>Dawn Over Kitty Hawk</I> and <I>Operation Iraqi Freedom.</I> Walter J. Boyne lives in Ashburn, Virginia</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?206ab718